<template>
  <div class="inner-container">
    <div class="page-tag">{{ title }}</div>
    <div class="tag-detail" v-if="subTitle">
      <div class="tag-detail_prefix"></div>
      <span>{{ subTitle }}</span>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
const props = defineProps({
  title:{
    type: String,
  },
  subTitle:{
    type: String,
  }
});
</script>

<style scoped lang="less">
.inner-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 1.01rem 1.01rem;
  font-weight: 500;
  .page-tag {
    width: fit-content;
    border-radius: 0.3rem;
    padding: 0.43rem 0.68rem;
    background-color: #0dcb8b;
    color: #ffffff;
    font-size: 0.95rem;
    margin: 0 0 1.01rem;
  }
  .tag-detail {
    color: #ffffff;
    font-size: 0.88rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.4rem;
    margin: 0 0 1.01rem;
    &_prefix {
      position: relative;
      width: 1.08rem;
      height: 0.68rem;
      &::before {
        content: "";
        display: block;
        width: 0.68rem;
        height: 0.68rem;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        background-color: #ffc57f;
      }
      &::after {
        content: "";
        display: block;
        width: 0.68rem;
        height: 0.68rem;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        background-color: #ff8c00;
      }
    }
  }
}
</style>
